package org.multiplatform.kotfolio.pages.shared

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul

@Page("viewmodel")
@Composable
fun ViewModelPage() {
    BlogLayout(
        PageProperties(
            "KMP Shared",
            ""
        ),
        BlogProperties("KMP Shared", "Shared -> SwiftUI ViewModel"))
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Wrapper Pattern: Common abstraction + platform implementations delegating to native SDKs.",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Android: Lifecycle Ownership via a Wrapper ViewModel",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Android has a well-defined lifecycle model, and ignoring it leads to memory leaks. To respect this, I wrap the shared ViewModel inside a native Android ViewModel. This wrapper owns the lifecycle and provides a lifecycle-aware CoroutineScope.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Approaches to bridge",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li {
                    SpanText(
                        text = "KMP-NativeCoroutines",
                        modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "A library that generates Swift-friendly wrappers automatically",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    SpanText(
                        text = "Manual wrapping",
                        modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "writing your own iosMain wrapper using DisposableHandle",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    SpanText(
                        text = "KMP-ObservableViewModel",
                        modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Allows you to use AndroidX/Kotlin ViewModels with SwiftUI.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    SpanText(
                        text = "swiftExport",
                        modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "It allows you to export Kotlin sources directly and call Kotlin code from Swift idiomatically, eliminating the need for Objective-C headers.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    SpanText(
                        text = "koin Wrapper",
                        modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Koin provides us with an all-in kotlin library to use it in our shared module to create injections that can be used by both Android and iOS platforms, and also with desktop, if you go with KMP (Kotlin MultiPlatform)",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li {
                    SpanText(
                        text = "SKIE (Swift Kotlin Interface Enhancer)",
                        modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                            .fontWeight(FontWeight.Bold)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Consuming Kotlin Flows in Swift without SKIE means writing manual coroutine management in every wrapper. SKIE makes StateFlow directly iterable with for await the wrapper becomes trivial to write.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "iOS: Bridging StateFlow to SwiftUI with an Observer Wrapper",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "SwiftUI relies on ObservableObject and @Published properties to drive UI updates. Kotlin, on the other hand, uses StateFlow. These two systems don’t communicate natively. To bridge this gap, I implemented an Observer Wrapper on the iOS side.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Don’t forget clear() on onDisappear.",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "On IOS, the coroutine scope doesn't cancel itself. One missing clear() call and you have a leak running background work on a screen the user already left.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Task",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "SwiftUI doesn't give you an explicit scope. Instead, you wrap the async call in Task, which creates an unstructured task. Unlike . task, this isn't tied to the view lifecycle. If needed, you can keep a reference to the task and cancel it manually - but for simple user-triggered actions, the syntax stays concise without requiring you to manage a scope object.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = ".task is SwiftUI's equivalent, introduced in iOS 15. It launches an async task tied to the view's lifetime, starts when the view appears, and is cancelled automatically when it disappears.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            //https://medium.com/@kmpbits
            KotlinCode(
                code = """
                    var body: some View {
                        Button ("Refresh") {
                            Task {
                                await viewModel.loadItems()
                            }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import Combine
                    import SwiftUI

                    @MainActor
                    class UserViewModel: ObservableObject {

                        @Published var users: [User] = []
                        @Published var isLoading = false

                        private let useCase: GetUsersUseCase

                        private var page = 1

                        init(useCase: GetUsersUseCase) {
                            self.useCase = useCase
                        }

                        func loadUsers() {
                            Task {
                                isLoading = true

                                do {
                                    let newUsers = try await useCase.execute(page: page)
                                    users.append(contentsOf: newUsers)
                                    page += 1
                                } catch {
                                    print(error)
                                }

                                isLoading = false
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Lifecycle Multiplatform ViewModels",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Google now officially recommends using Lifecycle-aware Multiplatform ViewModels in Kotlin Multiplatform projects.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In this approach, shared ViewModels inherit directly from androidx.lifecycle.ViewModel, which is available in commonMain. This allows shared code to use viewModelScope without injecting a coroutine scope manually.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    // shared/commonMain
                    import androidx.lifecycle.ViewModel
                    import androidx.lifecycle.viewModelScope

                    class SharedViewModel : ViewModel() {

                        fun doSomething() {
                            viewModelScope.launch {
                                // Shared coroutine scope available natively
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Simple Way (No DI) - https://github.com/fluttertutorialin/BookShared",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "swiftExport",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/Knthcame/CMPSwiftExport.git
            //https://github.com/jasi381/FirebaseAuthKMP.git
            KotlinCode(
                code = """
                    //https://github.com/fluttertutorialin/CmpSwiftExport
                    
                    import org.jetbrains.compose.desktop.application.dsl.TargetFormat
                    import org.jetbrains.kotlin.gradle.ExperimentalWasmDsl
                    import org.jetbrains.kotlin.gradle.dsl.JvmTarget
                    import org.jetbrains.kotlin.gradle.swiftexport.ExperimentalSwiftExportDsl

                    plugins {
                        alias(libs.plugins.kotlinMultiplatform)
                        alias(libs.plugins.androidApplication)
                        alias(libs.plugins.composeMultiplatform)
                        alias(libs.plugins.composeCompiler)
                        alias(libs.plugins.composeHotReload)
                    }

                    kotlin {
                        androidTarget {
                            compilerOptions {
                                jvmTarget.set(JvmTarget.JVM_25)
                            }
                        }

                        iosArm64()
                        iosSimulatorArm64()

                        @OptIn(ExperimentalSwiftExportDsl::class)
                        swiftExport {
                            moduleName = "ComposeApp"
                            flattenPackage = "com.knthcame.cmpswiftexport"
                            configure {
                                freeCompilerArgs.add("-Xexpect-actual-classes")
                            }
                        }

                        jvm()
                        
                        js {
                            browser()
                            binaries.executable()
                        }
                        
                        @OptIn(ExperimentalWasmDsl::class)
                        wasmJs {
                            browser()
                            binaries.executable()
                        }
                        
                        sourceSets {
                            androidMain.dependencies {
                                implementation(libs.compose.uiToolingPreview)
                                implementation(libs.androidx.activity.compose)
                            }
                            commonMain.dependencies {
                                implementation(libs.compose.runtime)
                                implementation(libs.compose.foundation)
                                implementation(libs.compose.material3)
                                implementation(libs.compose.ui)
                                implementation(libs.compose.components.resources)
                                implementation(libs.compose.uiToolingPreview)
                                implementation(libs.androidx.lifecycle.viewmodelCompose)
                                implementation(libs.androidx.lifecycle.runtimeCompose)
                            }
                            commonTest.dependencies {
                                implementation(libs.kotlin.test)
                            }
                            jvmMain.dependencies {
                                implementation(compose.desktop.currentOs)
                                implementation(libs.kotlinx.coroutinesSwing)
                            }
                        }
                    }

                    android {
                        namespace = "com.knthcame.cmpswiftexport"
                        compileSdk = libs.versions.android.compileSdk.get().toInt()

                        defaultConfig {
                            applicationId = "com.knthcame.cmpswiftexport"
                            minSdk = libs.versions.android.minSdk.get().toInt()
                            targetSdk = libs.versions.android.targetSdk.get().toInt()
                            versionCode = 1
                            versionName = "1.0"
                        }
                        packaging {
                            resources {
                                excludes += "/META-INF/{AL2.0,LGPL2.1}"
                            }
                        }
                        buildTypes {
                            getByName("release") {
                                isMinifyEnabled = false
                            }
                        }
                        compileOptions {
                            sourceCompatibility = JavaVersion.VERSION_19
                            targetCompatibility = JavaVersion.VERSION_19
                        }
                    }

                    dependencies {
                        debugImplementation(libs.compose.uiTooling)
                    }

                    compose.desktop {
                        application {
                            mainClass = "com.knthcame.cmpswiftexport.MainKt"

                            nativeDistributions {
                                targetFormats(TargetFormat.Dmg, TargetFormat.Msi, TargetFormat.Deb)
                                packageName = "com.knthcame.cmpswiftexport"
                                packageVersion = "1.0.0"
                            }
                        }
                    }
                    
                    //iosApp
                    import UIKit
                    import SwiftUI
                    import ComposeApp

                    struct ComposeView: UIViewControllerRepresentable {
                        func makeUIViewController(context: Context) -> UIViewController {
                            MainViewController()
                        }

                        func updateUIViewController(_ uiViewController: UIViewController, context: Context) {}
                    }

                    struct ContentView: View {
                        var body: some View {
                            ComposeView()
                                .ignoresSafeArea()
                        }
                    }
                    
                    //iosMain
                    import androidx.compose.ui.window.ComposeUIViewController

                    fun MainViewController() = ComposeUIViewController { App() }
                    """.trimIndent()
            )

            SpanText(
                text = "Koin KoinComponent Wrapper",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/igortfcorrea/FlightPriceTracker.git
            KotlinCode(
                code = """
                    //commonMain
                    
                    //di
                    fun initKoin() {
                        startKoin {
                            modules(sharedModule + getViewModelsModule())
                        }
                    }
                    
                    expect fun getViewModelsModule(): Module
                    
                    //FlowWrapper.kt
                    import kotlinx.coroutines.CoroutineScope
                    import kotlinx.coroutines.Dispatchers
                    import kotlinx.coroutines.flow.Flow
                    import kotlinx.coroutines.launch

                    class FlowWrapper<T>(
                        private val flow: Flow<T>
                    ) {
                        fun watch(block: (T) -> Unit): AutoCloseable {
                            val job = CoroutineScope(Dispatchers.Main).launch {
                                flow.collect {
                                    block(it)
                                }
                            }
                            return AutoCloseable { job.cancel() }
                        }
                    }

                    fun <T> Flow<T>.asWrapper() = FlowWrapper(this)
                    
                    interface FetchRecentSearchesUseCase {
                        suspend operator fun invoke(): List<RecentSearch>
                    }
                    
                    internal class FetchRecentSearchesUseCaseImpl : FetchRecentSearchesUseCase {

                        override suspend fun invoke(): List<RecentSearch> {
                            val mockedData = listOf(
                                RecentSearch(
                                    id = "1",
                                    origin = "GRU",
                                    destination = "JFK",
                                    description = "Best price",
                                    price = 540.0f
                                ),
                                RecentSearch(
                                    id = "2",
                                    origin = "GIG",
                                    destination = "VIX",
                                    description = "Best price",
                                    price = 50.0f
                                )
                            )
                            delay(2000)
                            return mockedData
                        }
                        
                    class HomeViewModel(
                        private val fetchRecentSearchesUseCase: FetchRecentSearchesUseCase
                    ) : ViewModel() {
                        private val _recentSearches = MutableStateFlow<List<RecentSearch>>(emptyList())
                        val recentSearches = _recentSearches.asStateFlow()
                        val recentSearchesWrapper = recentSearches.asWrapper()

                        fun fetchRecentSearches() {
                            viewModelScope.launch {
                                val recentSearches = fetchRecentSearchesUseCase.invoke()
                                _recentSearches.value = recentSearches
                            }
                        }
                    }
                    
                    //iosMain
                    private val viewModelModules = module {
                        single { HomeViewModel(get()) }
                    }

                    actual fun getViewModelsModule() = viewModelModules

                    object ProvideViewModel : KoinComponent {
                        fun getHomeViewModel(): HomeViewModel = get()
                    }
                    
                    //iosApp
                    import Foundation
                    import Shared

                    class HomeViewModelWrapper : ObservableObject {
                        var viewModel: HomeViewModel
                        private var closeable: KotlinAutoCloseable?

                        @Published var recentSearches: [RecentSearch] = []

                        init() {
                            self.viewModel = ProvideViewModel.shared.getHomeViewModel()

                            observe()
                            self.viewModel.fetchRecentSearches()
                        }

                        private func observe() {
                            closeable = viewModel.recentSearchesWrapper.watch { data in
                                let list = (data as? [RecentSearch]) ?? []
                                DispatchQueue.main.async {
                                    self.recentSearches = list
                                }
                            }
                        }

                        deinit {
                            closeable?.close()
                        }
                    }
                    
                    struct HomeView: View {
                        @StateObject private var homeViewModelWrapper = HomeViewModelWrapper()
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "KMP-ObservableViewModel",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/devjayswal/Kotlin_MultiPlatform_app_Koin.git
            KotlinCode(
                code = """
                    kmpObservableviewmodelCore = "1.0.3"
                    koin = ""
                    
                    kmp-observableviewmodel-core = { module = "com.rickclephas.kmp:kmp-observableviewmodel-core", version.ref = "kmpObservableviewmodelCore"}
                    
                    kotlin {
                        listOf(
                            iosArm64(),
                            iosSimulatorArm64()
                        ).forEach { iosTarget ->
                            iosTarget.binaries.framework {
                                baseName = "Shared"
                                isStatic = false

                                export(libs.kmp.observableviewmodel.core)
                            }
                        }
                    }
                    
                    //----- iosApp ----
                    //KMPObservableViewModelCore.swift
                    import KMPObservableViewModelCore
                    import Shared

                    extension Kmp_observableviewmodel_coreViewModel: @retroactive ViewModel {}
                    
                    //ContentView.swift
                    struct ContentView: View {
                        @StateViewModel var viewModel: SharedTestViewModel = ViewModelProvider().provideSharedTestViewModel()
                    }
                    
                    // Generic collector for Kotlin Flows
                    class Collector<T>: Kotlinx_coroutines_coreFlowCollector {
                        let callback: (T) -> Void

                        init(callback: @escaping (T) -> Void) {
                            self.callback = callback
                        }

                        func emit(value: Any?, completionHandler: @escaping (Error?) -> Void) {
                            if let value = value as? T {
                                callback(value)
                            }
                            completionHandler(nil)
                        }
                    }
                    
                    //----- iosMain ----
                    actual fun viewModelModule(): Module {
                        return module {
                            factory { SharedTestViewModel(get(), get()) }
                        }
                    }
                    
                    class ViewModelProvider : KoinComponent {
                        fun provideSharedTestViewModel() = get<SharedTestViewModel>()
                    }
                    
                    //----- commonMain ----
                   class SharedTestViewModel() : ViewModel() { }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //Generate shared file
                    
                    //android 
                    ./gradlew assembleRelease
                    
                    //ios
                    step: 1 XCFramework add
                    val xcf = XCFramework()
                    listOf(
                        iosArm64(),
                        iosSimulatorArm64()
                    ).forEach { iosTarget ->
                        iosTarget.binaries.framework {
                            baseName = "Shared"
                            isStatic = true
                            xcf.add(this)
                        }
                    }
                    
                    js {
                        outputModuleName = "shared"
                        browser()
                        binaries.library()
                        generateTypeScriptDefinitions()
                        compilerOptions {
                            target = "es2015"
                        }
                    }
    
                    //Terminal for ios Command
                    step: 2 ./gradlew :shared:linkReleaseFrameworkIosSimulatorArm64 --stacktrace
                    step: 3 ./gradlew assembleSharedReleaseXCFramework
                    step: 4 ./gradlew :composeApp:assemble
                    
                    ./gradlew :shared:clean :shared:linkReleaseFrameworkIosX64
                    ./gradlew :shared:build
                    
                    //Kotlin/JS
                    ./gradlew :shared:jsBrowserDevelopmentLibraryDistribution
                    ./gradlew jsBrowserDevelopmentWebpack
                    """.trimIndent()
            )

            //./gradlew appDistributionUploadDebug
            //./gradlew assembleDebug
            //./gradlew clean assembleRelease

            //https://github.com/Shieru292/kmp-todo-app.git
            KotlinCode(
                code = """
                    @Serializable
                    @JsExport
                    data class ToDo(val id: Int, val content: String)
                    
                    
                    //1 store
                    const [prices, setPrices] = useState<ElectricityPrice[]>([]);
                    const [todosPromise, setTodosPromise] = useState(() => _fetchAllToDo())
                    
                    //3 function call
                    const handleClick = () => {
                        if (isVisible) {
                       
                        } else {
                         
                        }
                      };

                    //2 RNShared
                    import kotlinx.coroutines.DelicateCoroutinesApi
                    import kotlinx.coroutines.GlobalScope
                    import kotlinx.coroutines.promise
                    import kotlin.js.Promise
                    import kotlin.js.collections.JsReadonlyArray

                    //list
                    @JsExport
                    fun fetchAllToDo(): Promise<JsReadonlyArray<ToDo>> = GlobalScope.promise {
                        fetchAllToDoSuspend().asJsReadonlyArrayView()
                    }
                    
                    //single
                    @Serializable
                    @JsExport
                    data class ToDo(val id: Int, val content: String)
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    //https://github.com/fluttertutorialin/BookShared.git
                    
                    import kotlinx.coroutines.CoroutineScope

                    expect open class PlatformViewModel() {
                        protected val  platformViewModelScope: CoroutineScope

                        protected open fun clear()
                    }
                    
                    //iosMain
                    actual open class PlatformViewModel {
                        private val scope: CoroutineScope by lazy(::buildScope)

                        protected actual val platformViewModelScope: CoroutineScope
                            get() = scope

                        private fun buildScope(): CloseableCoroutineScope = CloseableCoroutineScope(
                            SupervisorJob() + Dispatchers.Main.immediate
                        ).apply {
                            close()
                        }

                        protected actual open fun clear() {
                            scope.cancel()
                        }
                        
                        fun observeFLow(flow: StateFlow<*>, onChange: (Any?) -> Unit) {
                            platformViewModelScope.launch {
                                flow.collect { value ->
                                    onChange(value)
                                }
                            }
                        }
                    }

                    class CloseableCoroutineScope(
                        context: CoroutineContext
                    ) : CoroutineScope {

                        private val job = Job(context[Job])
                        override val coroutineContext: CoroutineContext = context + job

                        fun close() {
                            coroutineContext.cancel()
                        }
                    }
                    
                    //androidMain
                    actual open class PlatformViewModel : ViewModel(){
                        protected actual val platformViewModelScope: CoroutineScope
                            get() =  viewModelScope

                        protected actual open fun clear() {
                            super.onCleared()
                        }
                    }
                    """.trimIndent()
            )

            //https://medium.com/@ofek.amirav/how-i-solved-the-biggest-architectural-trap-in-kotlin-multiplatform-kmp-93e19b078337
            KotlinCode(
                code = """
                    import kotlinx.coroutines.CoroutineScope
                    import org.koin.core.component.KoinComponent

                    expect open class BaseViewModel() : KoinComponent {
                        val scope: CoroutineScope
                    }
                    
                    //androidMain
                    actual open class BaseViewModel : ViewModel(), KoinComponent {
                        actual val scope: CoroutineScope = viewModelScope
                    }
                    
                    //iosMain
                    actual open class BaseViewModel : KoinComponent {
                        actual val scope: CoroutineScope = CoroutineScope(Dispatchers.IO)

                        fun clear() {
                            scope.cancel()
                        }
                    }
                    
                    // commonMain — works identically on Android and iOS
                    class UserViewModel(
                        private val userUseCases: UserUseCases
                    ) : BaseViewModel() {
                    """.trimIndent()
            )

            SpanText(
                text = "koin InteropApi - Creating Methods to Retrieve Instances",
                modifier = Modifier.fontSize(FontSize.Large).padding(topBottom = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/InonELGABSI/TopOut
            KotlinCode(
                code = """
                    ---- common ---- 
                    factory { (scope: CoroutineScope) -> }
                    single<CoroutineScope> { CoroutineScope(SupervisorJob() + Dispatchers.Default) }
                    
                    import kotlinx.coroutines.CoroutineScope
                    import kotlinx.coroutines.flow.StateFlow

                    interface UiState

                    interface ViewStateHolder<S : UiState> {
                        val uiState: StateFlow<S>
                    }

                    expect abstract class BaseViewModel<S: UiState>() : ViewStateHolder<S> {
                        val scope: CoroutineScope
                    }
                    
                    ---- androidApp ---- 
                    //BaseViewModel.kt
                    import androidx.lifecycle.ViewModel
                    import androidx.lifecycle.viewModelScope
                    import kotlinx.coroutines.CoroutineScope
                    import kotlinx.coroutines.flow.StateFlow
                    import org.koin.core.component.KoinComponent

                    actual abstract class BaseViewModel<S: UiState>: ViewModel(), KoinComponent, ViewStateHolder<S> {
                        actual val scope: CoroutineScope = viewModelScope
                        abstract override val uiState: StateFlow<S>
                    }
                    
                    ---- iosApp ----
                    //Scope Access
                    private var backgroundScope: CoroutineScope? = null
                    backgroundScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
                    
                    //BaseViewModel.kt
                    import kotlinx.coroutines.CoroutineScope
                    import kotlinx.coroutines.Dispatchers
                    import kotlinx.coroutines.IO
                    import kotlinx.coroutines.SupervisorJob
                    import kotlinx.coroutines.cancel
                    import kotlinx.coroutines.flow.StateFlow
                    import org.koin.core.component.KoinComponent

                    actual abstract class BaseViewModel<S: UiState> : KoinComponent, ViewStateHolder<S> {

                        actual val scope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.IO)
                        abstract override val uiState: StateFlow<S>

                        fun clear() {
                            scope.cancel()
                        }
                    }
                    
                    //koin.kt
                    lateinit var sharedKoin: Koin

                    fun doInitKoin() {
                        initKoin()
                        sharedKoin = KoinPlatform.getKoin()
                    }

                    fun getSharedKoin(): Koin = sharedKoin

                    @OptIn(BetaInteropApi::class)
                    fun Koin.get(objCClass: ObjCClass): Any? {
                        val kClazz = getOriginalKotlinClass(objCClass) ?: return null
                        return get(kClazz, null, null)
                    }

                    @OptIn(BetaInteropApi::class)
                    fun Koin.get(
                        objCClass: ObjCClass,
                        qualifier: Qualifier?,
                        parameter: Any
                    ): Any? {
                        val kClazz = getOriginalKotlinClass(objCClass) ?: return null
                        return get(kClazz, qualifier) { parametersOf(parameter) }
                    }

                    //koinHelper.swift
                    import Foundation
                    import Shared

                    @inline(__always)
                    func get<T: AnyObject>(_ type: T.Type = T.self) -> T {
                        return Shared.sharedKoin.get(objCClass: type) as! T
                    }

                    func get<T: AnyObject>(_ type: T.Type,
                                           qualifier: Koin_coreQualifier? = nil,
                                           parameter: Any) -> T {
                        return Shared.sharedKoin.get(
                            objCClass: type,
                            qualifier: qualifier,
                            parameter: parameter
                        ) as! T
                    }
                    
                    //ViewModelWrapper.swift
                    import Foundation
                    import Shared

                    @MainActor
                    class ViewModelWrapper<UiState, ViewModel: BaseViewModel<UiState>>: ObservableObject {

                        let viewModel: ViewModel
                        @Published var uiState: UiState

                        init() {
                            self.viewModel = get()
                            self.uiState = viewModel.uiState.value
                        }

                        func startObserving() {
                            Task {
                                for await state in viewModel.uiState {
                                    self.uiState = state
                                }
                            }
                        }
                    }
                    
                    //swift
                    extension ProfileScreen {
                    @MainActor
                        class ProfileScreenModelWrapper: ObservableObject {
                            let viewModel: UserViewModel
                            @Published var uiState: UserState
                            init() {
                                // Koin provides the ViewModel - no constructor arguments needed
                                self.viewModel = KoinKt.userViewModel()
                                self.uiState = viewModel.uiState.value
                            }
                            func startObserving() {
                                Task {
                                    // SKIE makes Kotlin StateFlow iterable with Swift's for-await
                                    for await state in viewModel.uiState {
                                        self.uiState = state
                                    }
                                }
                            }
                        }
                    }
                    
                    //@StateObject private var wrapper = ProfileScreenModelWrapper()
                    """.trimIndent()
            )

            SpanText(
                text = "observableviewmodel",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/carla-voneicken/AppvancedPostsAppKMP.git
            KotlinCode(
                code = $$"""
                    plugins {
                        alias(libs.plugins.kotlinMultiplatform)
                        alias(libs.plugins.androidLibrary)
                        // KMP NativeCoroutines
                        id("com.rickclephas.kmp.nativecoroutines") version "1.0.1"
                        alias(libs.plugins.ksp)
                    }

                    kotlin {
                        androidTarget {
                            @OptIn(ExperimentalKotlinGradlePluginApi::class)
                            compilerOptions {
                                jvmTarget.set(JvmTarget.JVM_11)
                            }
                        }
                        
                        listOf(
                            iosX64(),
                            iosArm64(),
                            iosSimulatorArm64()
                        ).forEach { iosTarget ->
                            iosTarget.binaries.framework {
                                baseName = "Shared"
                                isStatic = true
                            }
                        }
                        
                        sourceSets {
                            all {
                                // KMP ObservableViewModel
                                languageSettings.optIn("kotlinx.cinterop.ExperimentalForeignApi")
                                // KMP NativeCoroutines
                                languageSettings.optIn("kotlin.experimental.ExperimentalObjCName")
                            }
                            commonMain.dependencies {
                                implementation(libs.koin.core)
                                implementation(libs.koin.compose)
                                implementation(libs.koin.compose.viewmodel)

                                implementation(libs.bundles.ktor)

                                implementation(libs.kotlinx.coroutines.core)
                                implementation(libs.kotlinx.serialization.core)
                                implementation(libs.kotlinx.serialization.json)

                                // KMP ObservableViewModel: https://github.com/rickclephas/KMP-ObservableViewModel
                                api("com.rickclephas.kmp:kmp-observableviewmodel-core:1.0.0-BETA-13")
                            }
                            commonTest.dependencies {
                                implementation(libs.kotlin.test)
                            }
                            androidMain.dependencies {
                                implementation(libs.ktor.client.okhttp)
                                implementation(libs.koin.android)
                            }
                            iosMain.dependencies {
                                implementation(libs.ktor.client.darwin)
                                implementation(libs.koin.core)
                            }
                        }
                    }

                    dependencies {
                        add("kspAndroid", libs.room.compiler)
                        add("kspIosSimulatorArm64", libs.room.compiler)
                        add("kspIosX64", libs.room.compiler)
                        add("kspIosArm64", libs.room.compiler)
                    }
                    
                    class PostDetailViewModel(
                        private val postId: Long?,
                        private val userId: Long
                    ): ViewModel(), KoinComponent {
                        private val observePostByIdUsecase: ObservePostByIdUsecase by inject()
                        private val refreshPostByIdUsecase: RefreshPostByIdUsecase by inject()
                        private val createPostUsecase: CreatePostUsecase by inject()
                        private val updatePostUsecase: UpdatePostUsecase by inject()

                        data class UiState(
                            val postId: Long? = null,
                            val userId: Long,
                            val post: Post? = null,
                            val title: String = "",
                            val body: String = "",
                            val errorMessage: String? = null,
                            val showError: Boolean = false,
                            val isSaved: Boolean = false
                        )

                        // Initiate the UiState
                        private val _uiState = MutableStateFlow(viewModelScope, UiState(userId = userId))

                        @NativeCoroutinesState
                        val uiState: StateFlow<UiState> = _uiState.asStateFlow()
                    }
                    
                    import SwiftUI
                    import KMPObservableViewModelSwiftUI
                    import Shared

                    struct PostDetailView: View {
                        @StateViewModel var viewmodel: PostDetailViewModel
                    }
                    
                    @NativeCoroutines
                    suspend fun <T> safeCall(
                        // block: the actual HTTP request or operation that could fail
                        block: suspend () -> HttpResponse,
                        // mapper: transforms the raw result of the block into the desired output type (e.g. List<Post>)
                        // it's generic so safeCall doesn't need to know in advance what the final type is, we supply it with the mapper
                        mapper: suspend (HttpResponse) -> T
                    ): NetworkResult<T, NetworkError> {
                        return try {
                            val response = block()  // run the HTTP request

                            /* check HTTP status codes returned by the server -> the request might succeed at the network
                            level, but the server responds with 401, 500 etc. */
                            when (response.status.value) {
                                in 200..299 -> {
                                    val body: T = mapper(response)
                                    NetworkResult.Success(body)
                                }
                                401 -> NetworkResult.Failure(NetworkError.UNAUTHORIZED)
                                408 -> NetworkResult.Failure(NetworkError.REQUEST_TIMEOUT)
                                409 -> NetworkResult.Failure(NetworkError.CONFLICT)
                                413 -> NetworkResult.Failure(NetworkError.PAYLOAD_TOO_LARGE)
                                in 500..599 -> NetworkResult.Failure(NetworkError.SERVER_ERROR)
                                else -> NetworkResult.Failure(NetworkError.UNKNOWN)
                            }
                        } catch (e: UnresolvedAddressException) {
                            NetworkResult.Failure(NetworkError.NO_INTERNET)
                        } catch (e: SerializationException) {
                            NetworkResult.Failure(NetworkError.SERIALIZATION)
                        } catch (e: Exception) {
                            NetworkResult.Failure(NetworkError.UNKNOWN)
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "ViewModelFactory (skie)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/filipebatista/KDragonBall.git (ViewModelFactory)
            KotlinCode(
                code = """
                    cocoapods {
                        summary = "Shared module for KDragonBall"
                        homepage = ""
                        version = "1.0"
                        ios.deploymentTarget = "14.0"
                        framework {
                            baseName = "shared"
                            isStatic = true
                            // Export ViewModels to iOS
                            export(libs.androidx.lifecycle.viewmodel)
                        }
                    }
                        
                    //commonMain
                    val sharedModules =
                        listOf(
                            coreModule,
                            characterModule,
                            planetModule,
                            transformationModule
                        )

                    // ViewModelFactory for iOS using Koin
                    object ViewModelFactories : KoinComponent {
                     
                        // Planet ViewModels
                        val planetListViewModelFactory: ViewModelProvider.Factory =
                            viewModelFactory {
                                initializer {
                                    val getPlanets: GetPlanets by inject()
                                    val searchPlanets: SearchPlanets by inject()
                                    PlanetListViewModel(getPlanets, searchPlanets)
                                }
                            }
                    }
                    
                    //iosMain
                    import androidx.lifecycle.ViewModel
                    import androidx.lifecycle.ViewModelProvider
                    import androidx.lifecycle.ViewModelStoreOwner
                    import androidx.lifecycle.viewmodel.CreationExtras
                    import kotlin.reflect.KClass
                    import kotlinx.cinterop.BetaInteropApi
                    import kotlinx.cinterop.ObjCClass
                    import kotlinx.cinterop.getOriginalKotlinClass

                    /**
                     * This function allows retrieving any ViewModel from Swift Code with generics.
                     * We only get [ObjCClass] type for the [modelClass], because the interop between Kotlin and Swift
                     * code doesn't preserve the generic class, but we can retrieve the original KClass in Kotlin.
                     */
                    @Suppress("unused") // Android Studio is not aware of iOS usage.
                    @OptIn(BetaInteropApi::class)
                    @Throws(IllegalStateException::class)
                    fun ViewModelStoreOwner.viewModel(
                        modelClass: ObjCClass,
                        factory: ViewModelProvider.Factory,
                        key: String?,
                        extras: CreationExtras? = null
                    ): ViewModel {
                        @Suppress("UNCHECKED_CAST")
                        val vmClass =
                            getOriginalKotlinClass(modelClass) as? KClass<ViewModel>
                                ?: error("modelClass isn't a ViewModel type")
                        val provider = ViewModelProvider.create(this, factory, extras ?: CreationExtras.Empty)
                        return key?.let { provider[key, vmClass] } ?: provider[vmClass]
                    }
                    
                    /**
                     * Helper object for initializing Koin from iOS.
                     */
                    object KoinHelper {
                        fun doInitKoin() {
                            startKoin {
                                modules(sharedModules)
                            }
                        }

                        fun doStopKoin() {
                            koinStop()
                        }
                    }
                    
                    //iosApp
                    import Foundation
                    import shared

                    class KoinInitializer {
                        static let shared = KoinInitializer()

                        func initialize() {
                            KoinHelper.shared.doInitKoin()
                        }

                        func stop() {
                            KoinHelper.shared.doStopKoin()
                        }
                    }

                    class AppDelegate: NSObject, UIApplicationDelegate {
                        func application(
                            _ application: UIApplication,
                            didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]? = nil
                        ) -> Bool {
                            // Initialize Koin on app launch
                            KoinInitializer.shared.initialize()

                            return true
                        }

                        func applicationWillTerminate(_ application: UIApplication) {
                            // Clean up Koin when app terminates
                            KoinInitializer.shared.stop()
                        }
                    }
                    
                    @main
                    struct iOSApp: App {
                        // Use UIApplicationDelegateAdaptor to connect AppDelegate
                        @UIApplicationDelegateAdaptor(AppDelegate.self) var appDelegate

                        var body: some Scene {
                            WindowGroup {
                                ContentView()
                            }
                        }
                    }
                    
                    import shared
                    import SwiftUI

                    /// A ViewModelStoreOwner specifically for iOS to be an ObservableObject.
                    class IosViewModelStoreOwner: ObservableObject, ViewModelStoreOwner {
                        var viewModelStore = ViewModelStore()

                        /// This function allows retrieving the androidx ViewModel from the store.
                        func viewModel<T: ViewModel>(
                            key: String? = nil,
                            factory: ViewModelProviderFactory,
                            extras: CreationExtras? = nil
                        ) -> T {
                            do {
                                guard let result = try viewModel(
                                    modelClass: T.self,
                                    factory: factory,
                                    key: key,
                                    extras: extras
                                ) as? T else {
                                    fatalError("Failed to cast ViewModel to type \(T.self)")
                                }
                                return result
                            } catch {
                                fatalError("Failed to create ViewModel of type \(T.self)")
                            }
                        }

                        /// This can be called from outside when using the `ViewModelStoreOwnerProvider`
                        func clear() {
                            viewModelStore.clear()
                        }

                        /// This is called when this class is used as a `@StateObject`
                        deinit {
                            viewModelStore.clear()
                        }
                    }
                    
                    struct PlanetListView: View {
                        let planetId: Int
                        @StateObject private var viewModelStoreOwner = IosViewModelStoreOwner()
                        @State private var searchText = ""

                        var body: some View {
                            let viewModel: PlanetListViewModel = viewModelStoreOwner.viewModel(
                                factory: ViewModelFactories.shared.planetListViewModelFactory
                            )
                            
                            //Argument
                            let viewModel: PlanetDetailViewModel = viewModelStoreOwner.viewModel(
                                factory: ViewModelFactories.shared.planetDetailViewModelFactory(planetId: Int32(planetId))
                            )
                       }
                    }    
                    """.trimIndent()
            )

            SpanText(
                text = "ViewModel to ViewModel Access",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/thejohnsondev/ArtSeum.git
            KotlinCode(
                code = """
                    //commonMain
                    class ArtListViewModel() : BaseViewModel() {
                    }
                    
                    //iosMain
                    class ViewModelFactory : KoinComponent {
                        fun makeArtListViewModel(): ArtListViewModel = get()
                    }
                    
                    //Access
                    private let viewModel: ArtListViewModel
                    init() {
                        self.viewModel = ViewModelFactory().makeArtListViewModel()
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "ViewModel Access",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    @MainActor
                    final class ModelSearchViewModel: ObservableObject {
                    }
                    
                    struct ModelSearchScreen: View {
                        @StateObject private var viewModel = ModelSearchViewModel()
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "View Pass Argument in ViewModel",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    @MainActor
                    final class ModelDetailViewModel: ObservableObject {
                         private let modelId: Int64
                         
                         init(modelId: Int64) {
                         }
                    }
                    
                    struct ModelDetailScreen: View {
                        @StateObject private var viewModel: ModelDetailViewModel

                        init(modelId: Int64) {
                            _viewModel = StateObject(wrappedValue: ModelDetailViewModel(modelId: modelId))
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "ViewModel Access UseCase KMP",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //try await
                    @MainActor
                    final class ModelSearchViewModel: ObservableObject {
                        private let getModelsUseCase: GetModelsUseCase
                        
                        init() {
                            self.getModelsUseCase = KoinHelper.shared.getModelsUseCase()
                        }
                        
                        let result = try await getModelsUseCase.invoke(
                            //parameter
                        )
                    }
                    
                    //iosMain
                    @Suppress("TooManyFunctions")
                    object KoinHelper {
                        fun getModelsUseCase(): GetModelsUseCase = getKoin().get()
                    }
                    
                    //SkieSwiftFlow
                    @MainActor
                    final class SettingsViewModel: ObservableObject {
                        private let observeNsfwFilterUseCase: ObserveNsfwFilterUseCase

                        init() {
                            self.observeNsfwFilterUseCase = KoinHelper.shared.getObserveNsfwFilterUseCase()
                        }

                        func observeNsfwFilter() async {
                            let flow = SkieSwiftFlow<NsfwFilterLevel>(observeNsfwFilterUseCase.invoke())
                        }
                    }
                    
                    //3 await
                    @MainActor
                    final class FavoritesViewModel: ObservableObject {
                        @Published var favorites: [FavoriteModelSummary] = []

                        private let observeFavoritesUseCase: ObserveFavoritesUseCase

                        init() {
                            self.observeFavoritesUseCase = KoinHelper.shared.getObserveFavoritesUseCase()
                        }

                        func observe() async {
                            for await list in observeFavoritesUseCase.invoke() {
                                let items = list.compactMap { $0 as? FavoriteModelSummary }
                                self.favorites = items
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "List Data Display",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //1
                    @MainActor
                    final class ModelSearchViewModel: ObservableObject {
                        @Published var searchHistory: [String] = []
                    }
                    
                    ForEach(viewModel.searchHistory, id: \.self) { item in 
                        //View
                    }
                    
                    //2
                    @MainActor
                    final class FavoritesViewModel: ObservableObject {
                        @Published var favorites: [FavoriteModelSummary] = []
                    }
                    
                    ForEach(viewModel.favorites, id: \.id) { model in
                        //View
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Variable & Function",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //Variable
                    
                    //weak & unowned
                    class Customer {
                        var account: Account?
                    }

                    class Account {
                        weak var owner: Customer?
                    }
                    
                    private var currentUser: User? = nil
                    
                    //enum
                    var currentView: AuthViewType = .login
                    enum AuthViewType: String {
                        case login
                    }
                    
                    var onDismiss: () -> Void = {}
                     
                    //Function 
                    private func randomNonceString(length: Int = 32) -> String { }
                    
                    private func sha256(_ input: String) -> String { }
                    
                    func setSetting(key: String, value: String) { 
                        return Int(value) ?? defaultValue
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "@observable + async/await - no Combine needed",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //ios 17+
                 
                    @Observable
                    class UserViewModel {
                        var users: [User] = []
                        func load() async {
                            users = await service.fetchUsers())
                        }
                    }        
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                     @MainActor
                     class AppleSignInManager: NSObject, ObservableObject {

                         static let shared = AppleSignInManager()
                     }
                     
                     struct LoginView: View {
                         @StateObject private var appleSignInManager = AppleSignInManager.shared
                     }
                """.trimIndent()
            )

            SpanText(
                text = "Return async Result",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/EfeObus/VwaTek-Apply.git
            KotlinCode(
                code = """
                     //Return result 
                     
                     @MainActor
                     class AppleSignInManager: NSObject, ObservableObject {
                         private var continuation: CheckedContinuation<Result<SignInResult, Error>, Never>?

                         private override init() {
                             super.init()
                         }

                         func signIn() async -> Result<SignInResult, Error> {
                             return await withCheckedContinuation { continuation in
                                 self.continuation = continuation
                                 controller.performRequests()
                             }
                         }
                     }
                     
                     //continuation?.resume(returning: .failure(error))
                     //continuation?.resume(returning: .success(result))
                     //continuation = nil
                     
                    //Get Result
                    @StateObject private var appleSignInManager = AppleSignInManager.shared
                      
                    Task {
                        let result = await appleSignInManager.signIn()
                        switch result {
                            case .success(let signInResult):
                            // Apple only provides name/email on first sign-in
                             
                            case .failure(let error):
                                // Check if user cancelled (code -999)
                                if (error as NSError).code != -999 {
                                    print("Apple Sign-In failed: \(error.localizedDescription)")
                                }
                            }
                    }
                """.trimIndent()
            )

            SpanText(
                text = "ViewState (Swift enum - Kotlin Sealed)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "@ViewBuilder (complex or conditional view) is a special attribute in SwiftUI that allows you to create custom views that can accept multiple child views. It enables you to return multiple views from a single closure without needing to wrap them in a container, such as VStack or HStack.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "ViewModifier is a protocol designed to encapsulate reusable styling (customize buttons, texts, or text fields) or behavior into a single, composable unit. By creating a custom modifier, you can apply the same styling or behavior across multiple views, keeping your code DRY (Don't Repeat Yourself).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    import Foundation

                    enum ViewState<T> {
                        case idle
                        case loading
                        case loaded(T)
                        case failure(String)
                    }
                    
                    @MainActor
                    final class HomeViewModel: ObservableObject {
                        @Published private(set) var state: ViewState<[Movie]> = .idle
                        
                        //state = .loading
                        //state = .loaded()
                        //state = .failure()
                    }
                    
                    @ViewBuilder
                    private var ForYouContent: some View {

                        switch vm.forYouState {
                            case .idle, .loading:
          
                            case .loaded(let movies):
                        }
                    }    
                    """.trimIndent()
            )

            SpanText(
                text = "Pass Data",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    private struct UserCardView: View {
                        let user: User
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = $$"""
                    //View Argument
                    struct SocialLoginButton: View {
                        let icon: String
                        var isLoading: Bool = false
                        let action: () -> Void
                    }
                  
                    struct FirstView: View {
                        @State private var username = "Kamlesh"

                        var body: some View {
                            NavigationStack {
                                NavigationLink("Open Second View") {
                                    SecondView(username: $username)
                                }
                            }
                        }
                    }

                    struct SecondView: View {
                        @Binding var username: String

                        var body: some View {
                            TextField("Enter Name", text: $username)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    class UserViewModel: ObservableObject {
                        @Published var name = "Kamlesh"
                    }
                    
                    struct FirstView: View {
                        @StateObject var viewModel = UserViewModel()

                        var body: some View {
                            NavigationStack {
                                NavigationLink("Next") {
                                    SecondView()
                                        .environmentObject(viewModel)
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    struct SecondView: View {
                        @EnvironmentObject var viewModel: UserViewModel

                        var body: some View {
                            Text(viewModel.name)
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Navigation",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            //https://github.com/asobrados03/HumanPerformApp.git
            KotlinCode(
                code = $$"""
                    import SwiftUI

                    enum AuthRoute: Hashable { case welcome, register, login, forgotPassword, passwordInfo }

                    struct AuthFlow: View {
                        let onLoginSuccess: () -> Void
                        @State private var path: [AuthRoute] = [.welcome]

                        var body: some View {
                            NavigationStack(path: $path) {
                                WelcomeView(
                                    onLogin:   { path = [.login] },
                                    onRegister:{ path = [.register] }
                                )
                                .navigationDestination(for: AuthRoute.self) { route in
                                    switch route {
                                    case .welcome:
                                        WelcomeView(
                                            onLogin:   { path = [.login] },
                                            onRegister:{ path = [.register] }
                                        )
                                    case .register:
                                        RegisterView(onNavigateToLogin: { path = [.login] })
                                    case .login:
                                        LoginView(
                                            onSuccess: {
                                                // aquí puedes guardar token en SecureStorage y el flow emitirá true
                                                onLoginSuccess()
                                            },
                                            onForgot:  { path.append(.forgotPassword) },
                                            onRegister:{ path = [.register] }
                                        )
                                    case .forgotPassword:
                                        EnterEmailView(onSuccess: { path.append(.passwordInfo) })
                                    case .passwordInfo:
                                        PasswordResetInfoView()
                                    }
                                }
                            }
                        }
                    }
                    
                    struct LoginView: View {
                        var onSuccess: (() -> Void)? = nil
                        var onForgot: (() -> Void)? = nil
                        var onRegister: (() -> Void)? = nil
                        
                        //onClick
                        onForgot?()
                    }
                    """.trimIndent()
            )
        }
    }
}

/*
@ViewBuilder
private var ForYouContent: some View {

}*/
//https://thecodingshef.in/batch/6 (Video using)
//https://github.com/teepeltola/SpotPrice.git (Web)
//https://medium.com/@fredosuala/kmp-architecture-the-case-for-pure-kotlin-viewmodels-c85ce95499ee
//func createSpan(spanName: String, eventName: String, attributes: [String: String] = [:]) { }

//View Model Factory
//https://github.com/rioX432/CivitDeck.git
//https://github.com/thejohnsondev/ArtSeum.git (Kotlin new version supported)
//https://github.com/TheRogue76/KMPWithSwift6.git
//https://github.com/filipebatista/KDragonBall.git (ViewModelFactory skie)
//https://github.com/carla-voneicken/AppvancedPostsAppKMP.git
//https://github.com/surajpsp/WhetherKKotlin.git
//https://github.com/Knthcame/MyHealthKMP.git (Heart Rate Flow, Skie, Kotlin 2.3.0)
//https://github.com/nyuksoonvong3432/KMPCompose-Todo-App
//https://github.com/HassanAlkuheli/CryptX.git (FloWrapper)
//https://codefylabs.hashnode.dev/shared-baseviewmodel-in-kotlin-multiplatform-kmp
//https://medium.com/@kmpbits
//https://github.com/aakash-mangukiya/KMM-Movie-App.git
//https://github.com/kmpbits/sharedFlowVsStateFlowDemo
//https://github.com/darius-it/kotlin-wasm-proto-initial.git (JS only)
//https://github.com/noob-programmer1/react-kmm-feasibility.git (KMM + React)
//https://github.com/jasi381/FirebaseAuthKMP.git
//https://github.com/devjayswal/Kotlin_MultiPlatform_app_Koin.git
//https://github.com/igortfcorrea/FlightPriceTracker.git (Koin Component Wrapper)
//https://github.com/Knthcame/CMPSwiftExport.git
//https://github.com/frankois944/Swift-Import-Interoperability-with-Kotlin-Multiplatform.git
//https://github.com/phpMyFAQ/MyFAQ.git
//https://www.storyblok.com/mp/introducing-native-api-clients-for-swift-kotlin
//https://github.com/felix-leyva/SimpleViewModelExample.git (Android, ios, kobweb all platform)
//https://github.com/sonmbol/KMPObservableBridge
//https://github.com/thesua7/KmpPlayground.git

//https://medium.com/@tahn98/swift-protocol-oriented-programming-in-swift-a-complete-guide-for-kotlin-developers-1efce51b2168

//https://github.com/IvanVoznyi/SwiftUI-Metal-List-Refresh-Animation- (MetalKit)

//print("Received from shared code: \(value)")

//  if #available(iOS 14.0, *) { } else { }

//Swift App
//https://www.getfeedbackkit.com (SDK)
//https://github.com/AhmedOmara14/SwiftUl.git (Clean Archi)
//https://github.com/Livsy90/EdgeDistortion